module.exports = __webpack_public_path__ + "img/frame (148).7e2b162a.jpg";